import "./suppressReactDevtools.ts";
import { startPing } from "./messaging.ts";
import "./ui/root.tsx";
import "./controls.ts";
import "./systems/lookup.ts";
import "./systems/selection.ts";
import "./systems/three.ts";
import "./systems/waterRipples.ts";
import "./systems/animation.ts";
import "./systems/action.ts";
import "./systems/sounds.ts";
import "./systems/blueprints.ts";
import "./systems/fire.ts";
import "./systems/projectile.ts";
import "./systems/buffModels.ts";
import "./systems/buffParticles.ts";
import "./systems/kaboom.ts";
import "./systems/easing.ts";
import "./systems/indicators.ts";
import "./systems/visualModifiers.ts";
import "./systems/fog.ts";
import "./systems/floatingText.ts";
import "./systems/birds.ts";
import "./systems/bees.ts";
import "./systems/healthbars.ts";
import "@/shared/systems/kd.ts";
import "@/shared/systems/vision.ts";
import "@/shared/systems/mapCenterMarker.ts";
import "./graphics/cursor.ts";

// Start the ping system
startPing();
